export enum NavbarGroupType {
  Default = 'default',
  LineTab = 'lineTab',
  Select = 'select',
}

export enum NavbarGroupLevel {
  Level1 = 'level1',
  Level2 = 'level2',
  Level3 = 'level3',
}

export type NavbarGroupTypeLevel =
  | {
      level: NavbarGroupLevel.Level1;
      type: NavbarGroupType.Default | NavbarGroupType.LineTab;
    }
  | {
      level: NavbarGroupLevel.Level2;
      type: NavbarGroupType.Select | NavbarGroupType.LineTab;
    }
  | {
      level: NavbarGroupLevel.Level3;
      type: NavbarGroupType.LineTab;
    };
